import React from 'react'
import {
  GRAPH_API_FRAGMENT_DEFINITION,
  GRAPH_API_FRAGMENT_REFERENCE,
} from '../../../utils/symbols'
import ListingSearchField from '../../formFields/listingSearchField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

const field = reduxFormFieldWrapper(fieldProps => (
  <ListingSearchField {...fieldProps} />
))

field[GRAPH_API_FRAGMENT_DEFINITION] =
  ListingSearchField[GRAPH_API_FRAGMENT_DEFINITION]
field[GRAPH_API_FRAGMENT_REFERENCE] =
  ListingSearchField[GRAPH_API_FRAGMENT_REFERENCE]

export default field
